const customColors = {
    primary: "#111315",
    secondary: "#2d2d2d",
    textPrimary: "#ffffff",
    textSecondary: "#dadde2",
    warning: "#b80707"
};

export default customColors;
